import extend from '@/utils/vuex-extend';
import {dialog, table} from '@/vuex-extend';
import {getOrderDetail, getReturnReasonList, fetchList} from '@/api/oms/order';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';

const responseHandle = async (dispatch, commit, state, payload) => {
	const orderCode = (payload && payload.orderCode) || state.orderCode;
	const {page: {pageNum, pageSize}} = state
	await wait(dispatch, 'oms.order.detail', async function () {
		let response = await getOrderDetail(orderCode);
		if (response.data) {
			const detail = response.data
			let orderListRes = await fetchList({
				showSkuValueList: true,
				showOrderLog: true,
				pageNum: pageNum,
				pageSize: pageSize,
				repeatFlag: true,
				userId: detail.userId,
				orderCode
			})
			detail.goodsList = detail.goodsList.map(item => {
				const tmp = item
				tmp.num = item.cnt
				return tmp
			})
			commit('save', {
				detail: detail,
				list: orderListRes.data.list,
				page: {
					pageSize: orderListRes.data.pageSize,
					total: orderListRes.data.total
				}
			})
		} else {
			Message.error({
				message: '无此订单',
				onClose: () => {
					dispatch('closeDialog')
				}
			})
		}
	})
}

export default extend(dialog, table, {
	namespaced: true,
	state: {
		orderCode: 0,
		detail: {},
		form: {},
		returnReasonList: [],
		list: [],
		page: {
			pageSize: 5
		}
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'oms.order.detail-list', async function () {
				const orderCode = (payload && payload.orderCode) || state.orderCode;
				const {detail} = state

				await dispatch('getData', {
					caller: fetchList,
					options: {
						repeatFlag: true,
						userId: detail.userId,
						orderCode,
						showSkuValueList: true,
						showOrderLog: true,
						...payload
					}
				});
			})
		},
		async afterOpenDialog({dispatch, commit, state}, payload) {
			// const {orderCode} = state;
			// await wait(dispatch, 'oms.order.detail', async function () {
			// 	let response = await getOrderDetail(orderCode);
			// 	if (response.data) {
			// 		const detail = response.data
			// 		let orderListRes = await fetchList({pageNum: 1, pageSize: 5, repeatFlag: true, userId: detail.userId, orderCode})
			// 		detail.goodsList = detail.goodsList.map(item => {
			// 			const tmp = item
			// 			tmp.num = item.cnt
			// 			return tmp
			// 		})
			// 		commit('save', {
			// 			detail: detail,
			// 			userOrderList: orderListRes.data.list
			// 		})
			// 	} else {
			// 		Message.error({
			// 			message: '无此订单',
			// 			onClose: () => {
			// 				dispatch('closeDialog')
			// 			}
			// 		})
			// 	}
			// })
			await responseHandle(dispatch, commit, state, payload)
		},
		async updateDetail({dispatch, commit, state}, payload) {
			await responseHandle(dispatch, commit, state, payload)
			// const orderCode = payload.orderCode || state.orderCode;
			// await wait(dispatch, 'oms.order.detail', async function () {
			// 	const response = await getOrderDetail(orderCode);
			// 	if (response.data) {
			// 		const detail = response.data
			// 		let orderListRes = await fetchList({pageNum: 1, pageSize: 5, repeatFlag: true, userId: detail.userId, orderCode})
			// 		detail.goodsList = detail.goodsList.map(item => {
			// 			const tmp = item
			// 			tmp.num = item.cnt
			// 			return tmp
			// 		})
			// 		commit('save', {
			// 			detail: detail,
			// 			userOrderList: orderListRes.data.list
			// 		})
			// 	} else {
			// 		Message.error({
			// 			message: '无此订单'
			// 		})
			// 	}
			// })
		},
		async getReturnReasonList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'oms.order.detail', async function () {
				await wait(dispatch, 'sms.order.return-reason-list', async function () {
					const response = await getReturnReasonList();
					if (response.data) {
						commit('save', {
							returnReasonList: response.data
						})
					}
				})
			})
		},
	},
	getters: {
		userData: state => {
			return [
				{
					label: 'Name',
					value: state.detail.name
				},
				{
					label: 'Address',
					value: state.detail.address
				},
				{
					label: 'PhoneNo',
					value: state.detail.phone
				},
				{
					label: 'Email',
					value: state.detail.email
				}
			]
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/order/detail.js